/* eslint "react/prop-types": "warn" */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';

import TableSidebar from './TableSidebar.jsx';
import SidebarLayout from 'platopulse/components/SidebarLayout.jsx';

import TableQuestions from "platopulse/reference/databases/TableQuestions.jsx"
import * as metadataActions from 'platopulse/redux/metadata';
import * as actions from 'platopulse/reference/reference';

import {
    getDatabase,
    getTable,
    getDatabaseId,
    getIsEditing
} from '../selectors';

import {
    loadEntities
} from 'platopulse/questions/questions';


const mapStateToProps = (state, props) => ({
    database: getDatabase(state, props),    
    table: getTable(state, props),    
    databaseId: getDatabaseId(state, props),
    isEditing: getIsEditing(state, props)
});

const mapDispatchToProps = {
    fetchQuestions: () => loadEntities("cards", {}),
    ...metadataActions,
    ...actions
};

@connect(mapStateToProps, mapDispatchToProps)
export default class TableQuestionsContainer extends Component {
    static propTypes = {
        params: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        database: PropTypes.object.isRequired,
        databaseId: PropTypes.number.isRequired,
        table: PropTypes.object.isRequired,
        isEditing: PropTypes.bool
    };

    async fetchContainerData() {
        await actions.wrappedFetchDatabaseMetadataAndQuestion(this.props, this.props.databaseId);
    }

    componentWillMount() {
        this.fetchContainerData()
    }

    componentWillReceiveProps(newProps) {
        if (this.props.location.pathname === newProps.location.pathname) {
            return;
        }

        actions.clearState(newProps)
    }

    render() {
        const {
            database,
            table,
            isEditing
        } = this.props;

        return (
            <SidebarLayout
                className="flex-full relative"
                style={ isEditing ? { paddingTop: '43px' } : {}}
                sidebar={<TableSidebar database={database} table={table}/>}
            >
                <TableQuestions {...this.props} />
            </SidebarLayout>
        );
    }
}



// WEBPACK FOOTER //
// ./reference/databases/TableQuestionsContainer.jsx